import styled, { css } from 'styled-components';

interface ContainerCardMeuPlanoProps {
  $disableClick?: boolean;
}

export const ContainerCardMeuPlano = styled.div<ContainerCardMeuPlanoProps>`
  display: flex;
  flex-direction: column;

  cursor: ${({ $disableClick }) => ($disableClick ? 'default' : 'pointer')};

  border: 0.0625rem solid #57069e;

  ${({ $disableClick }) =>
    !$disableClick &&
    css`
      &:hover {
        box-shadow: 0rem 0.25rem 0.5rem rgba(87, 6, 158, 0.2);
      }
    `}

  padding: 0.9375rem;
  border-radius: 0.5rem;
`;
